import { useMutation } from 'react-query';

import { createContract as mutationFn } from 'api/endPoints/createContract';

import { ProjectTreeNode } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';

export const useMutationCreateContract = () => {
    return useMutation<ICreateContractResponse, QueryError, ICreateContractPayload>((params) => mutationFn(params));
};

interface ICreateContractPayload {
    contractName: string;
    projectId: number;
}

interface ICreateContractResponse {
    id: number;
    contractUid: ProjectTreeNode['uuid'];
    name: string;
}
